/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import {CommonModule} from '@angular/common';
import {FILE_STORAGE_CONFIG} from './file-storage/file-storage.config';
import {AttachmentsViewComponent} from './attachments-view/attachments-view.component';
import {TranslateModule} from '@ngx-translate/core';
import {FileUploadModule} from "primeng/fileupload";

@NgModule({
  imports: [ButtonModule, CommonModule,
    TranslateModule,
    FileUploadModule
  ],
  declarations: [
    AttachmentsViewComponent
  ],
  exports: [
    AttachmentsViewComponent
  ]
})

export class FileStorageModule {

  static forRoot(config: { apiUrl: string }): ModuleWithProviders<FileStorageModule> {
    return {
      ngModule: FileStorageModule,
      providers: [
        {provide: FILE_STORAGE_CONFIG, useValue: config}
      ]
    };
  }
}
